import {Box, styled} from '@mui/material';

const TagWrapper = styled(Box)({
    display: 'flex',
    flexWrap: 'wrap',
    gap: '8px'
});

export default TagWrapper;
